import type { RealtimeEvent } from './helpers';

import { differenceInMinutes, parseISO } from 'date-fns';
import { css } from 'react-strict-dom';

import { Box, Text } from '../../../components';
import { Color } from '../../../constants';

type Props = Readonly<{
  allEvents: RealtimeEvent[];
}>;

export default function BoxNumOnline({ allEvents }: Props) {
  const numUsers = allEvents
    .filter(
      (event) =>
        differenceInMinutes(new Date(), parseISO(event.timestamp)) <= 10
    )
    .reduce<string[]>(
      (carry, event) =>
        carry.includes(event.user_id) ? carry : [...carry, event.user_id],
      []
    ).length;

  return (
    <Box title="Users Active Now">
      <Text as="div" style={styles.number(allEvents.length > 0)}>
        {numUsers}
      </Text>
    </Box>
  );
}

const styles = css.create({
  number: (nonZero: boolean) => ({
    textAlign: 'center',
    fontSize: 50,
    fontWeight: '400',
    color: nonZero ? Color.primaryVibrant : '#999',
    height: 140,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
});
